/**
 * 判断屏幕是否是横屏状态
 *
 * @return {Boolean} true 是 false  否
 */
export function isLandscape() {
  if (window.orientation == 180 || window.orientation == 0) {
    console.log("竖屏状态！");
    return false;
  }
  if (window.orientation == 90 || window.orientation == -90) {
    console.log("横屏状态！");
    return true;
  }
}

/**
 * 判断设备类型
 *
 * @return { Boolean } true 是 false  否
 */

export function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

export function isWeixin() {
  //判断是否是移动设备打开。browser代码在下面
  var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //在微信中打开
    return "wx";
  }
  if (ua.match(/WeiBo/i) == "weibo") {
    //在新浪微博客户端打开
    return "wb";
  }
  if (ua.match(/QQ/i) == "qq") {
    //在QQ空间打开
    return "qq";
  }
}

export function getImgs(context) {
  return new Promise((resolve) => {
    const files = context.keys();
    let list = [];
    files.forEach((item) => {
      const str = item.match(/\.png$/);
      const url = item.slice(2);
      // const key = url.split(".")[0];
      //     console.log(context(item), "context(item)");
      let obj = {
        label: str,
        value: `${url}`,
        url: context(item),
      };
      list.push(obj);
    });
    resolve(list);
  });
  //   console.log(obj, "objobj");
  // return obj;
}
